// extracted by mini-css-extract-plugin
export var orderSummary = "_r4-0";
export var showMoreLessButton = "_r4-1";